// KOMPLETTER NEUER CODE FÜR A7DemoBatches.js MIT DIAGNOSE-FUNKTIONEN

import React, { useState, useEffect, useRef } from "react";
import UserService from "../services/user.service"; // Assuming UserService handles API calls
import { Alert, Table, Container, Form, Pagination, Spinner, Button, Modal, Accordion, Row, Col } from 'react-bootstrap';
import { LoadScript, GoogleMap, Marker, Autocomplete, InfoWindow } from '@react-google-maps/api';
import { QRCodeCanvas } from 'qrcode.react';
import { Html5Qrcode } from 'html5-qrcode';


import { FaCheckCircle } from 'react-icons/fa'; // Ensure you have react-icons installed
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';




// +++ ANFANG: NEUE IMPORTS FÜR STRIPE +++
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripeCheckoutForm from './StripeCheckoutForm'; // Unsere neue Komponente
// +++ ENDE: NEUE IMPORTS FÜR STRIPE +++


import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBuilding, FaCreditCard, FaCheckCircle as FaCheck, FaArrowRight, FaArrowLeft, FaShoppingCart, FaTag } from 'react-icons/fa';
import { BsPersonBadge, BsCurrencyEuro } from 'react-icons/bs';
import { MdBusiness, MdLocationCity } from 'react-icons/md';

const batchURI= process.env.REACT_APP_API_BATCH_URL;
const DD=process.env.REACT_APP_DEFAULT_DURATION

function haltScanner(scanner) {
  const finish = () => {
    try { scanner.clear(); } catch (e) { /* bereits geschlossen */ }
  };
  try {
    const result = scanner.stop();
    if (result && typeof result.then === "function") {
      return result.catch(() => {}).finally(finish);
    }
  } catch (e) {
    /* Der Scanner war noch nicht gestartet. */
  }
  finish();
  return Promise.resolve();
}
const directURI= process.env.REACT_APP_API_DIRECT_URL;

function formatDeDate(value) {
  if (!value) return '–';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '–';
  return date.toLocaleDateString('de-DE');
}

function formatDeDateTime(value) {
  if (!value) return '–';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '–';
  return date.toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' });
}

function productEntryUrl(code) {
  const composed = String((code && code.service_in_url_with_in_url_code_generated) || '').trim();
  if (composed) return composed;
  const base = String((code && code.service_in_url) || '').trim();
  const hash = String((code && code.in_url_code_generated) || '').trim();
  if (base && hash) {
    if (base.endsWith('=') || base.endsWith('/') || base.endsWith('?')) return base + hash;
    return `${base.replace(/\/+$/, '')}/${hash}`;
  }
  return `${directURI || ''}${hash}`;
}

const libraries = ["places"];


// +++ ANFANG: DESIGN STYLES FÜR MODERNES MODAL +++
const modalStyles = {
  progressBar: {
    height: '6px',
    backgroundColor: '#E8F4FD',
    borderRadius: '10px',
    overflow: 'hidden',
    marginBottom: '30px',
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.06)'
  },
  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #4A90E2 0%, #26D0CE 100%)',
    borderRadius: '10px',
    transition: 'width 0.5s ease-in-out',
    boxShadow: '0 2px 8px rgba(74, 144, 226, 0.3)'
  },
  stepIndicator: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '25px',
    position: 'relative'
  },
  stepCircle: (isActive, isCompleted) => ({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isCompleted ? '#26D0CE' : isActive ? '#4A90E2' : '#E8E8E8',
    color: isActive || isCompleted ? 'white' : '#999',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    boxShadow: isActive ? '0 4px 12px rgba(74, 144, 226, 0.4)' : 'none',
    zIndex: 2
  }),
  sectionCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '25px',
    marginBottom: '20px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(74, 144, 226, 0.1)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '12px',
    borderBottom: '2px solid #F0F8FF',
    color: '#2C3E50'
  },
  inputGroup: {
    marginBottom: '18px'
  },
  label: {
    fontWeight: '500',
    color: '#34495E',
    marginBottom: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px'
  },
  formControl: {
    borderRadius: '8px',
    border: '1.5px solid #E0E6ED',
    padding: '10px 14px',
    fontSize: '15px',
    transition: 'all 0.3s ease',
    backgroundColor: '#FAFBFC'
  },
  primaryButton: {
    background: 'linear-gradient(135deg, #4A90E2 0%, #26D0CE 100%)',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 30px',
    fontWeight: '600',
    fontSize: '16px',
    boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
    transition: 'all 0.3s ease'
  },
  secondaryButton: {
    backgroundColor: '#F5F7FA',
    color: '#4A90E2',
    border: '2px solid #E0E6ED',
    borderRadius: '8px',
    padding: '12px 30px',
    fontWeight: '600',
    fontSize: '16px',
    transition: 'all 0.3s ease'
  },
  icon: {
    fontSize: '18px',
    color: '#4A90E2'
  }
};
// +++ ENDE: DESIGN STYLES FÜR MODERNES MODAL +++

const BatchCodeDemoADM = () => {
  const [batchCodes, setBatchCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('batch_code_id');
  const [sortOrder, setSortOrder] = useState('asc');
  const [tariffs, setTariffs] = useState([]);
  const [selectedTariffId, setSelectedTariffId] = useState(''); // Selected customer ID
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [customers, setCustomers] = useState([]); // List of customers
  const [selectedCustomerId, setSelectedCustomerId] = useState(''); // Selected customer ID
  const [demoDuration, setDemoDuration] = useState(30); // Default demo duration in minutes
  const [existingCustomerMessage, setExistingCustomerMessage] = useState('');

// +++ ANFANG: NEUE STATES FÜR DEN BEZAHLPROZESS +++
  const [selectedTariffInfo, setSelectedTariffInfo] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]); // Wird jetzt leer initialisiert
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(''); // Speichert die ID der Methode
  const [clientSecret, setClientSecret] = useState('');
  const [stripePromise, setStripePromise] = useState(null);
// +++ ENDE: NEUE STATES FÜR DEN BEZAHLPROZESS +++
  const [defaultDocTypeId, setDefaultDocTypeId] = useState(null); // NEU

// +++ ANFANG: NEUE STATES UND FUNKTIONEN FÜR MEHRSTUFIGEN DIALOG +++
  const [currentStep, setCurrentStep] = useState(1); // Startet bei Schritt 1

  // +++ ANFANG: NEUE STATES FÜR PAYMENT LINK +++
  const [paymentLinkUrl, setPaymentLinkUrl] = useState('');
  const [showQrCodeModal, setShowQrCodeModal] = useState(false);
  // +++ ENDE: NEUE STATES FÜR PAYMENT LINK +++

  const [pollingOrderId, setPollingOrderId] = useState(null);


  const nextStep = () => {
    // Validierung, bevor zum nächsten Schritt gegangen wird
    if (currentStep === 1 && !validateForm()) {
      setApiErrors("Bitte füllen Sie alle erforderlichen Felder aus, bevor Sie fortfahren.");
      return;
    }
    setApiErrors(""); // Fehler löschen, wenn die Validierung erfolgreich war
    setCurrentStep(prevStep => prevStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(prevStep => prevStep - 1);
  };
  // +++ ENDE: NEUE STATES UND FUNKTIONEN FÜR MEHRSTUFIGEN DIALOG +++

  const fetchPaymentMethods = async () => {
      try {
          const response = await UserService.getPaymentMethodsForAdm();
          const activeMethods = response.data.filter(m => m.is_active);
          setPaymentMethods(activeMethods); 
      } catch (error) {
          setApiErrors('Fehler beim Laden der Zahlungsarten.');
      }
    };  

  const [formDataSale, setFormDataSale] = useState({
    batch_code_id: null,
    placeId: '',
    place_name: '',
    place_address: '',
    latitude: '',
    longitude: '',
    customer_id: null, // Wichtig für die Zuordnung
    custumer_company_name: '',
    custumer_company_email: '',
    custumer_tax_number: '',
    custumer_tax_id: '',
    custumer_contact_firstname: '',
    custumer_contact_lastname: '',
    custumer_contact_mobile: '',
    custumer_postal_code: '',
    custumer_city: '',
    custumer_city_add: '',
    custumer_str: '',
    custumer_street_number: '',
    custumer_street_add: '',
    custumer_website: '',
    custumer_business_status: '',
    custumer_url: '',
    custumer_rating: '',
    custumer_user_ratings_total: '',
    custumer_formatted_address: '',


  });

  const [formData, setFormData] = useState({
    place_id: '',
    batch_code_id:'',
    place_name: '',
    place_address: '',
    latitude: '',
    longitude: '',
    
  });
  const DEFAULT_LOCATION = { lat: 50.9375, lng: 6.9603 }; // Coordinates for Cologne
  const [map, setMap] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [placeInfo, setPlaceInfo] = useState({
    placeId: "",
    name: "",
    address: "",
  });
  const [errors, setErrors] = useState({});
  
  
  const [markerPosition, setMarkerPosition] = useState(DEFAULT_LOCATION); // For Google Maps marker
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [nearbyLoading, setNearbyLoading] = useState(false);
  const [replacingPlace, setReplacingPlace] = useState(false);
  const [currentTargetLabel, setCurrentTargetLabel] = useState('');
 
  const inputRef = useRef(null);
  const batchCodeIdRef = useRef('');
  const [scanOpen, setScanOpen] = useState(false);
  const lookupRef = useRef(null);
  const apiKey = "AIzaSyDzLGEYu_8RPpFgtQZdhi9xS2HkGGUsb-k";
  const mapContainerStyle = {
    height: "400px",
    width: "100%",
  };

  // Extract relevant details

  const validateForm = () => {
    const newErrors = {};
  
    if (!selectedTariffId) {
      newErrors.tariff_id = "Tarifauswahl ist erforderlich";
    }
    if (!formDataSale.custumer_company_name) {
      newErrors.custumer_company_name = "Firmenname ist erforderlich";
    }
    if (!formDataSale.custumer_company_email) {
      newErrors.custumer_company_email = "E-Mail ist erforderlich";
    } else if (!/^\S+@\S+\.\S+$/.test(formDataSale.custumer_company_email)) {
      newErrors.custumer_company_email = "Ungültiges E-Mail-Format";
    }
    if (!formDataSale.custumer_contact_firstname) {
      newErrors.custumer_contact_firstname = "Vorname ist erforderlich";
    }
    if (!formDataSale.custumer_contact_lastname) {
      newErrors.custumer_contact_lastname = "Nachname ist erforderlich";
    }
    if (!formDataSale.custumer_postal_code) {
      newErrors.custumer_postal_code = "Postleitzahl ist erforderlich";
    }
    if (!formDataSale.custumer_city) {
      newErrors.custumer_city = "Stadt ist erforderlich";
    }
    if (!formDataSale.custumer_str) {
      newErrors.custumer_str = "Straße ist erforderlich";
    }
    if (!formDataSale.custumer_street_number) {
      newErrors.custumer_street_number = "Hausnummer ist erforderlich";
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const loadTariffs = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const responsetariff=await UserService.getTariffBoardADM();
      setTariffs(responsetariff.data.tariffs);
      
    } catch (error) {
      setApiErrors('Fehler beim Laden der Charge-Tarife');
    } finally {
      setLoading(false);
      
    }
  };

  const loadCustomers = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const response = await UserService.getCustomersADM(); // Replace with your API call to fetch customers
      setCustomers(response.data); // Assuming response.data contains an array of customers
    } catch (error) {
      setApiErrors('Fehler beim Laden der Kunden');
    } finally {
      setLoading(false);
    }
  };

  const inputStyles = {
    boxSizing: "border-box",
                  border: "1px solid transparent",
                  width: "240px",
                  height: "32px",
                  padding: "0 12px",
                  borderRadius: "3px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  outline: "none",
                  textOverflow: "ellipses",
  };

  // Load the batch codes, places, and customers from the backend
  useEffect(() => {
    loadBatchCodes();
    loadTariffs();
    loadCustomers(); 
    fetchPaymentMethods(); // <-- NEUE ZEILE
    loadDocumentTypes(); // <--- NEUER AUFRUF
  }, [currentPage, searchTerm, sortField, sortOrder]);


  const loadDocumentTypes = async () => {
    try {
      const response = await UserService.getDocumentTypes();
      const docTypes = response.data;
      
      const defaultDoc = docTypes.find(doc => doc.is_default);
      if (defaultDoc) {
        setDefaultDocTypeId(defaultDoc.doc_type_id);
      } else if (docTypes.length > 0) {
        setDefaultDocTypeId(docTypes[0].doc_type_id);
        setApiErrors('Keine Standard-Belegart gefunden. Die erste verfügbare Belegart wird verwendet.');
      } else {
        setApiErrors('Keine Belegarten verfügbar. Bitte kontaktieren Sie Ihren Vorgesetzten.');
      }
    } catch (error) {
      setApiErrors('Fehler beim Laden der Belegarten: ' + (error.response?.data?.message || error.message));
    }
  };

  const loadBatchCodes = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const response = await UserService.getDemoBatchOrders({
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder,
      });

      const batchCodesData = (response.data.activatedBatchCodes);
      setBatchCodes(batchCodesData);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setApiErrors('Fehler beim Laden der Charge-Codes');
    } finally {
      setLoading(false);
    }
  };

  
  

  // Effekt für das Polling des Zahlungsstatus
  useEffect(() => {
      if (!showQrCodeModal || !pollingOrderId) {
          return; // Nichts tun, wenn das Modal nicht sichtbar ist oder keine Order ID vorhanden ist
      }

      const intervalId = setInterval(async () => {
          try {
              // Dieser Aufruf sollte jetzt dank der neuen Route im Backend funktionieren
              const response = await UserService.getOrderStatus(pollingOrderId);

              if (response.data.status === 'paid') {
                  clearInterval(intervalId);
                  setShowQrCodeModal(false); 

                  // WICHTIG: Wir übergeben die ID der bestehenden Bestellung an die nächste Funktion.
                  handleSaleDemo(null, pollingOrderId);
              }
              
          } catch (error) {
              console.error("Fehler beim Polling:", error);
              // Polling bei Fehler stoppen, um eine Endlosschleife zu vermeiden.
              clearInterval(intervalId);
          }
      }, 5000); // Alle 5 Sekunden prüfen

      // Aufräumfunktion: Stoppt das Polling, wenn die Komponente verlassen wird oder das Modal sich schließt
      return () => {
          clearInterval(intervalId);
      };
  }, [showQrCodeModal, pollingOrderId]);

  

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  

  const openSaleModal = (bci, knownCode) => 
    {
      const existing = knownCode || batchCodes.find((c) => String(c.batch_code_id) === String(bci));
      let label = '';
      if (existing && existing.place) {
        try {
          const parsed = typeof existing.place === 'string' ? JSON.parse(existing.place) : existing.place;
          label = (parsed && (parsed.name || parsed.formattedAddress)) || '';
        } catch (e) {
          label = '';
        }
      }
      batchCodeIdRef.current = bci;
      const companyAlreadyChosen = !!(existing && (
        existing.sale_status === 'saled_to_customer' || (existing.demo_is_activated && existing.place_id)
      ));
      setReplacingPlace(companyAlreadyChosen);
      setCurrentTargetLabel(label || (existing && existing.place_id) || '');
      setNearbyPlaces([]);
      setApiErrors('');
      setFormData({
        place_id: '',
        batch_code_id: bci,
        place_name: '',
        place_address: '',
        latitude: '',
        longitude: '',
      });
      setModalIsOpen(true);};

  const lookupAndOpen = async (raw) => {
    try {
      const response = await UserService.lookupDemoCode(raw);
      const code = response.data && response.data.code;
      if (!code || !code.batch_code_id) {
        setApiErrors('QR-Code wurde nicht in Ihrem Bestand gefunden.');
        return;
      }
      setApiErrors('');
      openSaleModal(code.batch_code_id, code);
    } catch (error) {
      setApiErrors(error.response?.data?.message || 'QR-Code wurde nicht in Ihrem Bestand gefunden.');
    }
  };
  lookupRef.current = lookupAndOpen;

  useEffect(() => {
    if (!scanOpen) return undefined;
    let stopped = false;
    const readerId = 'demo-qr-reader';
    const scanner = new Html5Qrcode(readerId);
    scanner.start(
      { facingMode: 'environment' },
      { fps: 8, qrbox: { width: 240, height: 240 } },
      (decodedText) => {
        if (stopped) return;
        stopped = true;
        haltScanner(scanner).finally(() => {
          setScanOpen(false);
          if (lookupRef.current) lookupRef.current(decodedText);
        });
      },
      () => {}
    ).catch(() => {
      if (!stopped) {
        setApiErrors('Die Kamera konnte nicht gestartet werden. Bitte erlauben Sie den Kamerazugriff oder geben Sie die Seriennummer in die Suche ein.');
        setScanOpen(false);
      }
    });
    return () => {
      stopped = true;
      haltScanner(scanner);
    };
  }, [scanOpen]);

  const activateFromQuery = useRef(false);
  useEffect(() => {
    if (activateFromQuery.current) return;
    const activateId = new URLSearchParams(window.location.search).get("activate");
    if (!activateId) return;
    activateFromQuery.current = true;
    openSaleModal(activateId);
    const url = new URL(window.location.href);
    url.searchParams.delete("activate");
    window.history.replaceState({}, "", url.pathname + url.search);
  }, [batchCodes]);

  const closeSaleModal = () => {
    setModalIsOpen(false);
    setNearbyPlaces([]);
    setNearbyLoading(false);
    setCurrentTargetLabel('');
    setReplacingPlace(false);
    batchCodeIdRef.current = '';
    setFormData({ place_id: '', batch_code_id: '', place_name: '', place_address: '', latitude: '', longitude: '' }); // Reset form data
    
  };



  const closeSaleModal2 = () => {
    setModalIsOpen2(false);
    setApiErrors(''); // Setzt API-Fehler zurück
    setExistingCustomerMessage(''); // Setzt die Kunden-Nachricht zurück
    // Wichtig: Auch die Payment-States zurücksetzen
    setClientSecret('');
    setSelectedTariffId('');
    setSelectedTariffInfo(null);
    setCurrentStep(1); // Setzt beim Schließen auf Schritt 1 zurück
  };




  const openSaleModal2 = (bci, code) => {
    // Wichtig: Beim Öffnen die alten Zahlungsdaten und den Schritt zurücksetzen
    setCurrentStep(1); // Beginne immer bei Schritt 1
    setClientSecret('');
    setSelectedTariffId('');
    setSelectedTariffInfo(null);
    setApiErrors('');
    setExistingCustomerMessage('');

    let placeData;
    try {
      placeData = JSON.parse(code.place);
    } catch (error) {
      console.error("Fehler beim Parsen der Place-Daten:", error);
      setApiErrors("Fehler beim Laden der Ortsdaten");
      return;
    }

    const existingCustomer = customers.find(c => c.custumer_company_name === placeData.name);

    if (existingCustomer) {
      if (window.confirm('Ein Kunde mit diesem Namen existiert bereits. Wollen Sie die Daten übernehmen und an diesen Kunden verkaufen?')) {
        setExistingCustomerMessage('Bestehender Kunde gefunden. Die Daten wurden vor-ausgefüllt und können bearbeitet werden.');
        setFormDataSale({
          ...existingCustomer,
          customer_id: existingCustomer.customer_id, // Stelle sicher, dass die ID korrekt gesetzt wird
          batch_code_id: bci,
          placeId: placeData.placeId || existingCustomer.placeId || '',
        });
        setModalIsOpen2(true);
      } else {
        return;
      }
    } else {
      setFormDataSale({
        batch_code_id: bci,
        customer_id: null, // Neuer Kunde, noch keine ID
        custumer_company_name: placeData.name || '',
        custumer_company_email: '',
        custumer_tax_number: '',
        custumer_tax_id: '',
        custumer_contact_firstname: '',
        custumer_contact_lastname: '',
        custumer_contact_mobile: placeData.phoneNumber || '',
        custumer_postal_code: placeData.postalCode || '',
        custumer_city: placeData.city || '',
        custumer_city_add: '',
        custumer_str: placeData.route || '',
        custumer_street_number: placeData.streetNumber || '',
        custumer_street_add: '',
        custumer_website: placeData.website || '',
        custumer_business_status: placeData.businessStatus || '',
        custumer_url: placeData.url || '',
        custumer_rating: placeData.rating || '',
        custumer_user_ratings_total: placeData.userRatingsTotal || '',
        custumer_formatted_address: placeData.formattedAddress || '',
        placeId: placeData.placeId || '',
      });
      setModalIsOpen2(true);
    }
  };

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSaleChange = (e) => {
    const { name, value } = e.target;
    setFormDataSale((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSaleBlur = (e) => {
    validateForm();
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (!value) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: `${name.replace('_', ' ')} ist erforderlich.` }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleCancelDemo = async (e) => {
    try {
      const saleData = {
        batch_code_id: e,
      };
      await UserService.cancelDemoBatchCode(saleData);
      alert('Demo erfolgreich abgebrochen!');
      loadBatchCodes();
    } catch (error) {
      setApiErrors('Fehler beim Abbrechen der Demo.');
      console.error(error);
    }
  };

  function extractDetails(placeDetails) {
    const addressComponents = placeDetails.address_components || [];

    return {
      streetNumber: addressComponents.find(component => component.types.includes("street_number"))?.long_name || "",
      route: addressComponents.find(component => component.types.includes("route"))?.long_name || "",
      city: addressComponents.find(component => component.types.includes("locality"))?.long_name || "",
      postalCode: addressComponents.find(component => component.types.includes("postal_code"))?.long_name || "",
      country: addressComponents.find(component => component.types.includes("country"))?.long_name || "",
      phoneNumber: placeDetails.international_phone_number || placeDetails.formatted_phone_number || "",
      name: placeDetails.name || "",
      website: placeDetails.website || "",
      formattedAddress: placeDetails.formatted_address || "",
      businessStatus: placeDetails.business_status || "",
      placeId: placeDetails.place_id || "",
      url: placeDetails.url || "",
      rating: placeDetails.rating || "",
      userRatingsTotal: placeDetails.user_ratings_total || 0
    };
  }

  const handleActivateDemo = async () => {
    try {
      if (!formData.place_id ) {
        setApiErrors('Sie müssen ein Unternehmen auswählen.');
        return;
      }
      
      let tmpJsonData = formData.tmp_json;
      if (typeof tmpJsonData === 'string') {
        try {
          tmpJsonData = JSON.parse(tmpJsonData);
        } catch (e) {
          console.error("Fehler beim Parsen von tmp_json:", e);
        }
      }
      
      const saleData = {
        tmp_json: tmpJsonData,
        place_id: formData.place_id,
        demo_duration: formData.demo_duration,
        batch_code: formData.batch_code_id || batchCodeIdRef.current,
        duration: demoDuration,
        place_name: formData.place_name,
        place_address: formData.place_address,
        latitude: formData.latitude,
        longitude: formData.longitude,
      };
      await UserService.activateDemoBatchCodes(saleData);
      setApiErrors('');
      alert(replacingPlace ? 'Zielunternehmen wurde geändert.' : 'Charge-Codes sind jetzt aktiviert!');
      closeSaleModal();
      loadBatchCodes();
    } catch (error) {
      const serverMessage = error.response?.data?.error || error.response?.data?.message || error.message;
      setApiErrors('Charge-Codes wurden nicht aktiviert. ' + serverMessage);
      console.error('Charge-Codes wurden nicht aktiviert.:', error);
    }
  };
  const handleSaveCustomerAndProceed = async () => {
    if (!validateForm()) {
      setApiErrors('Bitte füllen Sie alle erforderlichen Kundenfelder aus.');
      return;
    }
    setLoading(true);
    setApiErrors('');
    try {
      const response = await UserService.createCustomerBoard(formDataSale); 
      const newCustomer = response.data;

      setFormDataSale(prevData => ({ ...prevData, customer_id: newCustomer.customer_id }));
      setExistingCustomerMessage(newCustomer.existing
        ? "Dieser Kunde ist bereits vorhanden und wird für den Verkauf verwendet."
        : "Kunde erfolgreich gespeichert.");
      loadCustomers(); 
      
      // AUTOMATISCH ZUM NÄCHSTEN SCHRITT
      nextStep();

    } catch (error) {
        setApiErrors("Fehler beim Speichern des neuen Kunden: " + (error.response?.data?.message || error.message));
    } finally {
        setLoading(false);
    }
  };
  
  const handleInitiatePayment = async (mode) => {
      setApiErrors('');
      setClientSecret('');
      setStripePromise(null);
      setPaymentLinkUrl('');
      setPollingOrderId(null);

      const customerId = formDataSale.customer_id;

      if (!selectedTariffInfo || !customerId || !selectedPaymentMethodId) {
        setApiErrors("Bitte wählen Sie einen Tarif und eine Zahlungsart und stellen Sie sicher, dass ein Kunde zugeordnet ist.");
        return;
      }
      if (!defaultDocTypeId) {
        setApiErrors("Keine Belegart verfügbar. Bitte kontaktieren Sie Ihren Vorgesetzten zur Einrichtung einer Standard-Belegart.");
        return;
      }

      const selectedMethod = paymentMethods.find(m => m.payment_method_id.toString() === selectedPaymentMethodId);
      if (!selectedMethod) {
          setApiErrors("Ausgewählte Zahlungsmethode nicht gefunden.");
          return;
      }

      const useQr = mode === 'qr' || selectedMethod.provider_key === 'PAY_LINK';
      setLoading(true);
      try {
          if (!useQr && selectedMethod.provider_key === 'STRIPE') {
              const sessionData = {
                  tariff_id: selectedTariffInfo.tariff_id,
                  customer_id: customerId,
                  payment_method_id: selectedPaymentMethodId
              };
              const response = await UserService.createPaymentSession(sessionData);
              const publishableKey = response.data.publishableKey;
              if (!publishableKey || !String(publishableKey).startsWith('pk_')) {
                setApiErrors('Der veröffentlichbare Stripe-Schlüssel in der Zahlungsmethode muss mit pk_test_ oder pk_live_ beginnen und zum geheimen Schlüssel desselben Kontos gehören.');
                return;
              }
              setStripePromise(loadStripe(publishableKey));
              setClientSecret(response.data.clientSecret);

          } else if (useQr && (selectedMethod.provider_key === 'STRIPE' || selectedMethod.provider_key === 'PAY_LINK')) {
              const linkData = {
                  tariff_id: selectedTariffInfo.tariff_id,
                  customer_id: customerId,
                  payment_method_id: selectedPaymentMethodId,
                  batch_code_id: formDataSale.batch_code_id,
                  doc_type_id: defaultDocTypeId
              };
              const response = await UserService.createPaymentLink(linkData);
              if (response.data.alreadyPaid) {
                await handleSaleDemo(null, response.data.order_id);
                return;
              }
              setPaymentLinkUrl(response.data.paymentLinkUrl);
              setPollingOrderId(response.data.order_id);
              setShowQrCodeModal(true);

          } else {
              handleSaleDemo(null);
          }
      } catch (error) {
          const details = error.response?.data?.details || error.response?.data?.message || error.message;
          setApiErrors("Fehler bei der Initialisierung der Zahlung: " + details);
      } finally {
          setLoading(false);
      }
  };

  // +++ ANFANG: ANGEPASSTE FINALE VERKAUFSFUNKTION +++
  const handleSaleDemo = async (psp_payment_id = null, existing_order_id = null) => {
    if (!validateForm()) {
      setApiErrors('Bitte füllen Sie alle erforderlichen Felder aus.');
      return;
    }

    try {
      setApiErrors('');
      setLoading(true);

      // ES GIBT NUR DIESE EINE DEFINITION VON saleData
      const saleData = {
          ...formDataSale,
          tariff_id: selectedTariffId,
          psp_payment_id: psp_payment_id,
          existing_order_id: existing_order_id,
          doc_type_id: defaultDocTypeId
      };

      // KORREKTUR: Der Name im Backend erwartet 'batch_codes', nicht 'batch_code_id'
      saleData.batch_codes = saleData.batch_code_id;
      delete saleData.batch_code_id;


      await UserService.sellDemoBatchCodes(saleData);

      alert('Charge-Codes erfolgreich verkauft!');
      closeSaleModal2();
      loadBatchCodes();

    } catch (error) {
      setApiErrors('Fehler beim Verkauf der Charge-Codes: ' + (error.response?.data?.details || error.response?.data?.error || error.response?.data?.message || error.message));
      console.error('Fehler beim Verkauf:', error);
    } finally {
        setLoading(false);
    }
  };
  // +++ ENDE: ANGEPASSTE FINALE VERKAUFSFUNKTION +++

  useEffect(() => {
    if (modalIsOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [modalIsOpen]);

  const onLoad = (mapInstance) => {
    setMap(mapInstance);
  };

  const onUnmount = () => {
    setMap(null);
  };

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const applyGooglePlace = (place) => {
    if (!place || !place.geometry || !place.geometry.location) {
      return;
    }
    const details = extractDetails(place);
    setMarkerPosition(place.geometry.location);
    setPlaceInfo({
      placeId: place.place_id,
      name: place.name || "Unbekanntes Unternehmen",
      address: place.formatted_address,
    });
    if (map) {
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }
    }
    const updatedFormData = {
      tmp_json: JSON.stringify(details),
      place_id: place.place_id,
      place_name: place.name || "",
      place_address: place.formatted_address || "",
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      batch_code_id: batchCodeIdRef.current || formData.batch_code_id,
    };
    setFormData(updatedFormData);
    setNearbyPlaces([]);
    setApiErrors('');
    setIsInfoWindowOpen(true);
  };

  const searchNearbyCompanies = (latLng) => {
    if (!map || !window.google || !window.google.maps || !window.google.maps.places) {
      setApiErrors('Die Karte ist noch nicht bereit. Bitte einen Moment warten und erneut versuchen.');
      return;
    }
    setNearbyLoading(true);
    setNearbyPlaces([]);
    const service = new window.google.maps.places.PlacesService(map);
    service.nearbySearch({
      location: latLng,
      radius: 1200,
      type: 'establishment',
    }, (results, status) => {
      setNearbyLoading(false);
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !Array.isArray(results) || results.length === 0) {
        setNearbyPlaces([]);
        setApiErrors('Im Umkreis wurden keine Unternehmen gefunden.');
        return;
      }
      setApiErrors('');
      setNearbyPlaces(results.slice(0, 12));
    });
  };

  const selectNearbyCompany = (result) => {
    if (!map || !result || !result.place_id || !window.google) return;
    const service = new window.google.maps.places.PlacesService(map);
    service.getDetails({
      placeId: result.place_id,
      fields: ['place_id', 'name', 'formatted_address', 'geometry', 'address_components', 'international_phone_number', 'formatted_phone_number', 'website', 'business_status', 'url', 'rating', 'user_ratings_total'],
    }, (place, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) {
        setApiErrors('Das Unternehmen konnte nicht übernommen werden.');
        return;
      }
      applyGooglePlace(place);
    });
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      applyGooglePlace(autocomplete.getPlace());
    }
  };
  
  return (
    <Container>
      <h1>Demo Charge-Code-Verwaltung</h1>

      <Form.Group controlId="searchBatchCode">
        <Form.Label>Bestand durchsuchen</Form.Label>
        <Form.Control
          type="text"
          placeholder="Seriennummer, QR-Code oder Charge-Code-ID"
          value={searchTerm}
          onChange={handleSearchChange}
          aria-label="Seriennummer, QR-Code oder Charge-Code-ID"
          style={{ minHeight: 44 }}
        />
        <Form.Text>Gefundene Codes aus Ihrem Bestand können Sie auswählen und als Demo aktivieren.</Form.Text>
      </Form.Group>
      <Button variant="outline-primary" className="mt-2 mb-3" style={{ minHeight: 44 }} onClick={() => { setApiErrors(''); setScanOpen(true); }}>
        QR-Code mit Kamera scannen
      </Button>
      {apiErrors && !modalIsOpen && !modalIsOpen2 && <Alert variant="danger">{apiErrors}</Alert>}

      {loading && <Spinner animation="border" />}
      
      <div className="table-responsive">
      <Table striped bordered hover>
      <thead>
        <tr>
          <th onClick={() => handleSortChange('batch_code_id')}>Charge-Code-ID</th>
          <th onClick={() => handleSortChange('batch_name')}>Chargenname</th>
          <th onClick={() => handleSortChange('batch_quantity')}>Menge</th>
          <th onClick={() => handleSortChange('pin')}>PIN</th>
          <th onClick={() => handleSortChange('in_url_code_generated')}>QR-Code</th>
          <th>QR-Bild</th>
          <th onClick={() => handleSortChange('buyer_id')}>Käufer-ID</th>
          <th onClick={() => handleSortChange('buyer_name')}>Käufername</th>
          <th onClick={() => handleSortChange('seller_id')}>Verkäufer-ID</th>
          <th onClick={() => handleSortChange('seller_name')}>Verkäufername</th>
          <th onClick={() => handleSortChange('batch_date')}>Chargendatum</th>
          <th onClick={() => handleSortChange('demo_activated_at')}>Demo aktiviert (Standard für {DD} Min.)</th>
          <th>Aktiviert</th>
          <th>Auswählen</th>
          <th>Verkaufen</th>
        </tr>
      </thead>
      <tbody>
        {batchCodes.length > 0 ? (
          batchCodes.map((code) => (
            <tr 
              key={code.batch_code_id} 
              style={code.sale_status === 'saled_to_customer' ? { backgroundColor: '#c3e6cb' } : {}}
            >
              <td>{code.batch_code_id}</td>
              <td>{code.batch_name}</td>
              <td>{code.batch_quantity}</td>
              <td style={{ whiteSpace: 'nowrap', fontFamily: 'ui-monospace, monospace' }}>{code.pin || '–'}</td>
              <td style={{ whiteSpace: 'nowrap', fontFamily: 'ui-monospace, monospace' }}>
                {code.in_url_code_generated ? (
                  <a href={productEntryUrl(code)} target="_blank" rel="noopener noreferrer">
                    {code.in_url_code_generated}
                  </a>
                ) : (
                  '–'
                )}
              </td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                {code.in_url_code_generated ? (
                  <a
                    href={productEntryUrl(code)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`QR-Bild für ${code.in_url_code_generated} öffnen`}
                    style={{ display: 'inline-flex', minWidth: 44, minHeight: 44, alignItems: 'center', justifyContent: 'center' }}
                  >
                    <QRCodeCanvas
                      value={productEntryUrl(code)}
                      size={88}
                      level="M"
                      includeMargin
                      bgColor="#ffffff"
                      fgColor="#1f2d3d"
                    />
                  </a>
                ) : (
                  '–'
                )}
              </td>
              <td>{code.buyer_id != null ? code.buyer_id : '–'}</td>
              <td>{code.buyer_name || '–'}</td>
              <td>{code.seller_id != null ? code.seller_id : '–'}</td>
              <td>{code.seller_name || '–'}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{formatDeDate(code.batch_date)}</td>
              <td>{formatDeDateTime(code.demo_activated_at)}</td>

              <td>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {code.demo_is_activated && code.place_id ? (
                    <>
                      <FaCheckCircle style={{ color: "green" }} title="Aktiviert" />
                      <Button 
                        variant="danger" 
                        onClick={() => handleCancelDemo(code.batch_code_id)}
                      >
                        Demo abbrechen
                      </Button>
                    </>
                  ) : (
                    "Nicht aktiviert"
                  )}
                </div>
              </td>
              <td>
                <Button 
                  variant="primary" 
                  onClick={() => openSaleModal(code.batch_code_id)}
                  style={{ minHeight: 44 }}
                >
                  {(code.sale_status === 'saled_to_customer' || (code.demo_is_activated && code.place_id)) ? 'Unternehmen ändern' : 'Aktivieren'}
                </Button>
              </td>
              <td>
                <Button 
                  variant="success" 
                  onClick={() => openSaleModal2(code.batch_code_id,code)}
                  disabled={!code.demo_is_activated || !code.place_id}
                >
                  Demo-Charge verkaufen
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="15" className="text-center">Keine Charge-Codes in Ihrem Bestand gefunden.</td>
          </tr>
        )}
      </tbody>
    </Table>
      </div>

      <Pagination>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item 
            key={index} 
            active={index + 1 === currentPage} 
            onClick={() => setCurrentPage(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      <Modal show={scanOpen} onHide={() => setScanOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>QR-Code scannen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Halten Sie den QR-Code aus Ihrem Bestand vor die Kamera.</p>
          <div id="demo-qr-reader" style={{ width: '100%' }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" style={{ minHeight: 44 }} onClick={() => setScanOpen(false)}>Schließen</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modalIsOpen} onHide={closeSaleModal}>
        <Modal.Header closeButton>
          <Modal.Title>Ort und Kunde für Verkauf auswählen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
          {currentTargetLabel && (
            <p style={{ marginBottom: 12 }}>
              Aktuelles Zielunternehmen: <strong>{currentTargetLabel}</strong>
            </p>
          )}
          <LoadScript googleMapsApiKey={apiKey} libraries={libraries}>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={markerPosition || { lat: -34.397, lng: 150.644 }}
              zoom={13}
              onLoad={onLoad}
              onUnmount={onUnmount}
            >
              <div style={{ position: "absolute", top: 10, left: 10, zIndex: 5 }}>
                <Autocomplete
                  onLoad={onLoadAutocomplete}
                  onPlaceChanged={onPlaceChanged}
                >
                  <input
                    id="pac-input"
                    className="controls"
                    type="text"
                    placeholder="Unternehmen und Standort eingeben"
                    ref={inputRef}
                    aria-label="Unternehmen und Standort eingeben"
                    style={{ 
                      width: 'min(400px, calc(100vw - 80px))', 
                      height: '44px', 
                      padding: '0 10px',
                      border: '2px solid red',
                      borderRadius: '5px'
                    }}
                  />
                </Autocomplete>
                {(nearbyLoading || nearbyPlaces.length > 0) && (
                  <div
                    role="listbox"
                    aria-label="Unternehmen in der Nähe"
                    style={{
                      marginTop: 8,
                      width: 'min(400px, calc(100vw - 80px))',
                      maxHeight: 220,
                      overflowY: 'auto',
                      background: '#fff',
                      borderRadius: 8,
                      boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
                    }}
                  >
                    {nearbyLoading && <div style={{ padding: 12 }}>Unternehmen werden gesucht …</div>}
                    {nearbyPlaces.map((item) => (
                      <button
                        type="button"
                        role="option"
                        key={item.place_id}
                        onClick={() => selectNearbyCompany(item)}
                        style={{
                          display: 'block',
                          width: '100%',
                          textAlign: 'left',
                          minHeight: 44,
                          padding: '8px 12px',
                          border: 0,
                          borderBottom: '1px solid #eee',
                          background: '#fff',
                          cursor: 'pointer',
                        }}
                      >
                        <strong>{item.name}</strong>
                        <br />
                        <span style={{ color: '#555', fontSize: 13 }}>{item.vicinity || item.formatted_address}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div style={{ position: "absolute", bottom: 90, right: 10, zIndex: 5 }}>
                <button
                  type="button"
                  onClick={() => {
                    if (!navigator.geolocation) {
                      setApiErrors("Standort konnte nicht ermittelt werden.");
                      return;
                    }
                    navigator.geolocation.getCurrentPosition(
                      (position) => {
                        const newPos = {
                          lat: position.coords.latitude,
                          lng: position.coords.longitude,
                        };
                        setMarkerPosition(newPos);
                        if (map) {
                          map.setCenter(newPos);
                          map.setZoom(15);
                        }
                        setIsInfoWindowOpen(true);
                        searchNearbyCompanies(newPos);
                      },
                      () => {
                        setApiErrors("Standort konnte nicht ermittelt werden.");
                      }
                    );
                  }}
                  style={{
                    backgroundColor: 'white',
                    border: 'none',
                    borderRadius: '2px',
                    width: '44px',
                    height: '44px',
                    cursor: 'pointer',
                    boxShadow: 'rgb(0 0 0 / 30%) 0px 1px 4px -1px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                  title="Mein Standort"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24">
                    <path 
                      d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                      fill="#666"
                    />
                  </svg>
                </button>
              </div>
              {markerPosition && (
                <Marker position={markerPosition} onClick={() => setIsInfoWindowOpen(true)} />
              )}
              {isInfoWindowOpen && (
                <InfoWindow
                  position={markerPosition}
                  onCloseClick={() => setIsInfoWindowOpen(false)}
                >
                  <div>
                    <strong>{placeInfo.name}</strong>
                    <br />
                    <span>{placeInfo.address}</span>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          </LoadScript>
          <div style={{ marginTop: '20px' }}>
            <Form.Group controlId="formAreaGroupName">
              <Form.Label>Orts-ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Orts-ID eingeben"
                name="place_id"
                value={formData.place_id}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.place_id}
                readOnly
              />
              <Form.Control.Feedback type="invalid">
                {errors.place_id}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formPlaceName">
              <Form.Label>Ortsname</Form.Label>
              <Form.Control
                type="text"
                name="place_name"
                value={formData.place_name}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="formPlaceAddress">
              <Form.Label>Ortsadresse</Form.Label>
              <Form.Control
                type="text"
                name="place_address"
                value={formData.place_address}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly
              />
            </Form.Group>
          </div>
          <Form.Control type="hidden" name="place_name" value={formData.place_name} />
          <Form.Control type="hidden" name="place_address" value={formData.place_address} />
          <Form.Control type="hidden" name="latitude" value={formData.latitude} />
          <Form.Control type="hidden" name="longitude" value={formData.longitude} />
          <Form.Control type="hidden" name="tmp_json" value={typeof formData.tmp_json === 'string' ? formData.tmp_json : JSON.stringify(formData.tmp_json || {})} />
          <style>{`
            .pac-container {
              z-index: 10000 !important;
            }
          `}</style>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeSaleModal}>
            Schließen
          </Button>
          <Button variant="primary" onClick={handleActivateDemo} style={{ minHeight: 44 }}>
            {replacingPlace ? 'Unternehmen speichern' : 'Demo aktivieren'}
          </Button>
        </Modal.Footer>
      </Modal>


  {/* ============================================================================================ */}
  {/* ======================= ANFANG: NEUES, MEHRSTUFIGES VERKAUFSMODAL ======================= */}
  {/* ============================================================================================ */}
  <Modal show={modalIsOpen2} onHide={closeSaleModal2} size="lg" backdrop="static">
    <Modal.Header closeButton style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
      color: 'white',
      borderBottom: 'none',
      borderRadius: '0'
    }}>
      <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: '600' }}>
        <FaShoppingCart /> Demo-Charge Verkaufen
      </Modal.Title>
    </Modal.Header>

    <Modal.Body style={{ 
      background: 'linear-gradient(180deg, #F8FAFE 0%, #FFFFFF 100%)',
      padding: '30px'
    }}>
      {/* Progress Bar */}
      <div style={modalStyles.progressBar}>
        <div style={{...modalStyles.progressFill, width: currentStep === 1 ? '50%' : '100%'}}></div>
      </div>

      {/* Step Indicators */}
      <div style={modalStyles.stepIndicator}>
        <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <div style={modalStyles.stepCircle(currentStep === 1, false)}>
            {currentStep > 1 ? <FaCheck /> : '1'}
          </div>
          <div style={{ 
            flex: 1, 
            height: '2px', 
            background: currentStep > 1 ? 'linear-gradient(90deg, #26D0CE 0%, #4A90E2 100%)' : '#E8E8E8',
            margin: '0 10px'
          }}></div>
        </div>
        <div style={modalStyles.stepCircle(currentStep === 2, false)}>2</div>
      </div>

      {/* Step Labels */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px', paddingLeft: '8px', paddingRight: '8px' }}>
        <span style={{ fontSize: '13px', color: currentStep === 1 ? '#4A90E2' : '#26D0CE', fontWeight: '600' }}>
          Kundendaten
        </span>
        <span style={{ fontSize: '13px', color: currentStep === 2 ? '#4A90E2' : '#999', fontWeight: currentStep === 2 ? '600' : '400' }}>
          Zahlung
        </span>
      </div>

      {apiErrors && (
        <Alert variant="danger" style={{ 
          borderRadius: '10px', 
          border: 'none',
          background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
          color: 'white'
        }}>
          {apiErrors}
        </Alert>
      )}
      
      {existingCustomerMessage && (
        <Alert variant="info" style={{ 
          borderRadius: '10px',
          backgroundColor: '#E3F2FD',
          border: '1px solid #90CAF9',
          color: '#1565C0'
        }}>
          <FaCheckCircle style={{ marginRight: '8px' }} />
          {existingCustomerMessage}
        </Alert>
      )}

      {/* === SCHRITT 1: KUNDENDATEN & TARIFWAHL === */}
      {currentStep === 1 && (
        <div style={{ animation: 'fadeIn 0.5s ease' }}>
          {/* Allgemeine Informationen Card */}
          <div style={modalStyles.sectionCard}>
            <div style={modalStyles.sectionHeader}>
              <FaTag style={{ ...modalStyles.icon, marginRight: '10px' }} />
              <h5 style={{ margin: 0, fontWeight: '600' }}>Allgemeine Informationen</h5>
            </div>
            <Row>
              <Col md={6}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <BsPersonBadge />
                    Charge-Code-ID
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    value={formDataSale.batch_code_id || ''} 
                    readOnly
                    style={{
                      ...modalStyles.formControl,
                      backgroundColor: '#F0F4F8',
                      cursor: 'not-allowed'
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <BsCurrencyEuro />
                    Tarif auswählen *
                  </Form.Label>
                  <Form.Control
                    as="select"
                    value={selectedTariffId}
                    onChange={(e) => {
                      const newTariffId = e.target.value;
                      setSelectedTariffId(newTariffId);
                      const tariffDetails = tariffs.find(t => t.tariff_id.toString() === newTariffId);
                      setSelectedTariffInfo(tariffDetails);
                      setClientSecret('');
                    }}
                    onBlur={handleSaleBlur}
                    isInvalid={!!errors.tariff_id}
                    style={{
                      ...modalStyles.formControl,
                      border: errors.tariff_id ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  >
                    <option value="">Tarif auswählen...</option>
                    {tariffs.map(mvos => (
                      <option key={mvos.tariff_id} value={mvos.tariff_id}>
                        {mvos.tariff_name} ({mvos.amount_eur_net}€ / {mvos.amount_period_net})
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">{errors.tariff_id}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Kundendaten Card */}
          <div style={modalStyles.sectionCard}>
            <div style={modalStyles.sectionHeader}>
              <FaUser style={{ ...modalStyles.icon, marginRight: '10px' }} />
              <h5 style={{ margin: 0, fontWeight: '600' }}>Kundendaten (Erforderlich)</h5>
            </div>
            <Row>
              <Col md={6}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <FaBuilding />
                    Firmenname *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_company_name" 
                    value={formDataSale.custumer_company_name || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_company_name}
                    placeholder="Firmenname eingeben"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_company_name ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_company_name}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <FaEnvelope />
                    E-Mail-Adresse *
                  </Form.Label>
                  <Form.Control 
                    type="email" 
                    name="custumer_company_email" 
                    value={formDataSale.custumer_company_email || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_company_email}
                    placeholder="email@beispiel.de"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_company_email ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_company_email}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <FaUser />
                    Vorname *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_contact_firstname" 
                    value={formDataSale.custumer_contact_firstname || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_contact_firstname}
                    placeholder="Max"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_contact_firstname ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_contact_firstname}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <FaUser />
                    Nachname *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_contact_lastname" 
                    value={formDataSale.custumer_contact_lastname || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_contact_lastname}
                    placeholder="Mustermann"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_contact_lastname ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_contact_lastname}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <FaMapMarkerAlt />
                    Straße *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_str" 
                    value={formDataSale.custumer_str || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_str}
                    placeholder="Musterstraße"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_str ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_str}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    Hausnummer *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_street_number" 
                    value={formDataSale.custumer_street_number || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_street_number}
                    placeholder="123"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_street_number ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_street_number}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    PLZ *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_postal_code" 
                    value={formDataSale.custumer_postal_code || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_postal_code}
                    placeholder="12345"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_postal_code ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_postal_code}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={8}>
                <Form.Group style={modalStyles.inputGroup}>
                  <Form.Label style={modalStyles.label}>
                    <MdLocationCity />
                    Stadt *
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    name="custumer_city" 
                    value={formDataSale.custumer_city || ''} 
                    onChange={handleSaleChange} 
                    onBlur={handleSaleBlur} 
                    isInvalid={!!errors.custumer_city}
                    placeholder="Musterstadt"
                    style={{
                      ...modalStyles.formControl,
                      border: errors.custumer_city ? '2px solid #FF6B6B' : modalStyles.formControl.border
                    }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.custumer_city}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Optionale Daten Card */}
          <Accordion>
            <Accordion.Item eventKey="0" style={{ 
              border: 'none', 
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <Accordion.Header style={{ backgroundColor: '#F8FAFE' }}>
                <MdBusiness style={{ marginRight: '10px', color: '#4A90E2' }} />
                Optionale Unternehmensdaten
              </Accordion.Header>
              <Accordion.Body style={{ backgroundColor: 'white' }}>
                <Row>
                  <Col md={6}>
                    <Form.Group style={modalStyles.inputGroup}>
                      <Form.Label style={modalStyles.label}>
                        <FaPhone />
                        Mobilnummer
                      </Form.Label>
                      <Form.Control 
                        type="text" 
                        name="custumer_contact_mobile" 
                        value={formDataSale.custumer_contact_mobile || ''} 
                        onChange={handleSaleChange}
                        style={modalStyles.formControl}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group style={modalStyles.inputGroup}>
                      <Form.Label style={modalStyles.label}>
                        Steuernummer
                      </Form.Label>
                      <Form.Control 
                        type="text" 
                        name="custumer_tax_number" 
                        value={formDataSale.custumer_tax_number || ''} 
                        onChange={handleSaleChange}
                        style={modalStyles.formControl}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group style={modalStyles.inputGroup}>
                      <Form.Label style={modalStyles.label}>
                        Steuer-ID
                      </Form.Label>
                      <Form.Control 
                        type="text" 
                        name="custumer_tax_id" 
                        value={formDataSale.custumer_tax_id || ''} 
                        onChange={handleSaleChange}
                        style={modalStyles.formControl}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group style={modalStyles.inputGroup}>
                      <Form.Label style={modalStyles.label}>
                        Website
                      </Form.Label>
                      <Form.Control 
                        type="text" 
                        name="custumer_website" 
                        value={formDataSale.custumer_website || ''} 
                        onChange={handleSaleChange}
                        style={modalStyles.formControl}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      )}

      {/* === SCHRITT 2: ZAHLUNG === */}
      {currentStep === 2 && (
        <div style={{ animation: 'fadeIn 0.5s ease' }}>
          <div style={{
            ...modalStyles.sectionCard,
            background: 'linear-gradient(135deg, #E3F2FD 0%, #F3E5F5 100%)',
            border: '2px solid #4A90E2'
          }}>
            <div style={modalStyles.sectionHeader}>
              <FaCheck style={{ color: '#26D0CE', fontSize: '24px', marginRight: '12px' }} />
              <div>
                <h5 style={{ margin: 0, fontWeight: '600', color: '#2C3E50' }}>Kundendaten erfolgreich gespeichert!</h5>
                <small style={{ color: '#7F8C8D' }}>Bitte wählen Sie nun die Zahlungsmethode</small>
              </div>
            </div>
            
            <div style={{ 
              backgroundColor: 'white', 
              borderRadius: '8px', 
              padding: '15px',
              marginTop: '15px'
            }}>
              <Row>
                <Col md={6}>
                  <p style={{ margin: '5px 0', color: '#34495E' }}>
                    <strong>Kunde:</strong> {formDataSale.custumer_company_name}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={{ margin: '5px 0', color: '#34495E' }}>
                    <strong>Tarif:</strong> {selectedTariffInfo?.tariff_name || 'N/A'} 
                    <span style={{ 
                      marginLeft: '10px',
                      padding: '3px 10px',
                      backgroundColor: '#4A90E2',
                      color: 'white',
                      borderRadius: '15px',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}>
                      {selectedTariffInfo?.amount_eur_net}€
                    </span>
                  </p>
                </Col>
              </Row>
            </div>
          </div>

          <div style={modalStyles.sectionCard}>
            <div style={modalStyles.sectionHeader}>
              <FaCreditCard style={{ ...modalStyles.icon, marginRight: '10px' }} />
              <h5 style={{ margin: 0, fontWeight: '600' }}>Zahlungsmethode wählen</h5>
            </div>
            
            <Form.Group style={modalStyles.inputGroup}>
              <Form.Label style={modalStyles.label}>
                Verfügbare Zahlungsarten
              </Form.Label>
              <Form.Control 
                as="select" 
                value={selectedPaymentMethodId} 
                onChange={(e) => setSelectedPaymentMethodId(e.target.value)}
                style={{
                  ...modalStyles.formControl,
                  fontSize: '16px',
                  padding: '12px'
                }}
              >
                <option value="">Bitte wählen...</option>
                {paymentMethods.map(method => (
                  <option key={method.payment_method_id} value={method.payment_method_id}>
                    {method.method_name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            {!clientSecret && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center', marginTop: '30px' }}>
                {paymentMethods.find(m => m.payment_method_id.toString() === selectedPaymentMethodId)?.provider_key === 'STRIPE' ? (
                  <>
                    <Button
                      onClick={() => handleInitiatePayment('card')}
                      disabled={loading || !selectedTariffInfo || !selectedPaymentMethodId}
                      style={{ ...modalStyles.primaryButton, minHeight: 48, padding: '14px 28px', fontSize: '16px' }}
                    >
                      {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Karte hier eingeben'}
                    </Button>
                    <Button
                      onClick={() => handleInitiatePayment('qr')}
                      disabled={loading || !selectedTariffInfo || !selectedPaymentMethodId}
                      style={{
                        minHeight: 48,
                        padding: '14px 28px',
                        fontSize: '16px',
                        fontWeight: 700,
                        borderRadius: '8px',
                        background: '#FBBC04',
                        border: 'none',
                        color: '#1f2d3d'
                      }}
                    >
                      {loading ? <Spinner as="span" animation="border" size="sm" /> : 'QR-Code für den Kunden'}
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={() => handleInitiatePayment(paymentMethods.find(m => m.payment_method_id.toString() === selectedPaymentMethodId)?.provider_key === 'PAY_LINK' ? 'qr' : 'other')}
                    disabled={loading || !selectedTariffInfo || !selectedPaymentMethodId}
                    style={{ ...modalStyles.primaryButton, padding: '14px 40px', fontSize: '18px', minHeight: 48 }}
                  >
                    {loading ? (
                      <Spinner as="span" animation="border" size="sm" />
                    ) : (
                      <>
                        <FaCreditCard style={{ marginRight: '8px' }} />
                        {selectedTariffInfo?.amount_period_net !== 'onetime' ? 'Abonnement einrichten' : 'Zur Kasse'}
                      </>
                    )}
                  </Button>
                )}
              </div>
            )}

            {clientSecret && stripePromise && selectedPaymentMethodId && (
              <div style={{
                marginTop: '30px',
                padding: '20px',
                backgroundColor: '#F8FAFE',
                borderRadius: '10px',
                border: '1px dashed #4A90E2'
              }}>
                <h5 style={{ 
                  marginBottom: '20px',
                  color: '#2C3E50',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  <FaCreditCard style={{ color: '#4A90E2' }} />
                  Zahlung sicher abschließen
                </h5>
                <Elements options={{ clientSecret }} stripe={stripePromise}>
                  <StripeCheckoutForm 
                    onPaymentSuccess={(paymentIntent) => {
                      handleSaleDemo(paymentIntent.id); 
                    }}
                    onPaymentError={(error) => {
                      setApiErrors(`Zahlungsfehler: ${error.message}`);
                    }}
                  />
                </Elements>
              </div>
            )}
          </div>
        </div>
      )}
    </Modal.Body>

    <Modal.Footer style={{ 
      backgroundColor: '#F8FAFE',
      borderTop: '2px solid #E8F4FD',
      padding: '20px 30px'
    }}>
      {currentStep > 1 && (
        <Button 
          onClick={prevStep} 
          disabled={loading}
          style={modalStyles.secondaryButton}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#E8F4FD';
            e.target.style.borderColor = '#4A90E2';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#F5F7FA';
            e.target.style.borderColor = '#E0E6ED';
          }}
        >
          <FaArrowLeft style={{ marginRight: '8px' }} />
          Zurück
        </Button>
      )}

      {currentStep === 1 && (
        <>
          <Button 
            onClick={closeSaleModal2}
            style={modalStyles.secondaryButton}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#FFE5E5';
              e.target.style.borderColor = '#FF6B6B';
              e.target.style.color = '#FF6B6B';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#F5F7FA';
              e.target.style.borderColor = '#E0E6ED';
              e.target.style.color = '#4A90E2';
            }}
          >
            Abbrechen
          </Button>
          
          {formDataSale.customer_id ? (
            <Button 
              onClick={nextStep} 
              disabled={loading}
              style={modalStyles.primaryButton}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(74, 144, 226, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(74, 144, 226, 0.3)';
              }}
            >
              Weiter zur Zahlung
              <FaArrowRight style={{ marginLeft: '8px' }} />
            </Button>
          ) : (
            <Button 
              onClick={handleSaveCustomerAndProceed} 
              disabled={loading}
              style={modalStyles.primaryButton}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(74, 144, 226, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(74, 144, 226, 0.3)';
              }}
            >
              {loading ? (
                <Spinner as="span" animation="border" size="sm" />
              ) : (
                <>
                  Kunde speichern & Weiter
                  <FaArrowRight style={{ marginLeft: '8px' }} />
                </>
              )}
            </Button>
          )}
        </>
      )}
      
      {currentStep === 2 && !clientSecret && (
        <Button 
          onClick={closeSaleModal2}
          style={modalStyles.secondaryButton}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#FFE5E5';
            e.target.style.borderColor = '#FF6B6B';
            e.target.style.color = '#FF6B6B';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#F5F7FA';
            e.target.style.borderColor = '#E0E6ED';
            e.target.style.color = '#4A90E2';
          }}
        >
          Abbrechen
        </Button>
      )}
    </Modal.Footer>

    <style jsx>{`
      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      .form-control:focus {
        border-color: #4A90E2 !important;
        box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.25) !important;
        background-color: #FFFFFF !important;
      }
      
      .form-control:hover:not(:focus) {
        border-color: #26D0CE !important;
      }
    `}</style>
  </Modal>
  {/* ======================== ENDE: NEUES, MEHRSTUFIGES VERKAUFSMODAL ======================== */}

    {/* ============================================================================================ */}
    {/* ======================= ANFANG: NEUES MODAL FÜR QR-CODE-ANZEIGE ======================== */}
    {/* ============================================================================================ */}
    <Modal show={showQrCodeModal} onHide={() => setShowQrCodeModal(false)} centered>
        <Modal.Header closeButton style={{ borderBottom: 'none' }}>
            <Modal.Title>Zahlung per QR-Code</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center" style={{ padding: '0.5rem 1.5rem 1.5rem' }}>
            <p style={{ color: '#5b6b7e', marginBottom: '1rem' }}>
                Der Kunde scannt diesen Code mit dem Handy und bezahlt dort.
            </p>
            {paymentLinkUrl && (
                <div style={{ display: 'inline-block', padding: '16px', background: '#fff', borderRadius: '16px', boxShadow: '0 8px 24px rgba(31,45,61,0.12)' }}>
                    <QRCodeCanvas
                        value={paymentLinkUrl}
                        size={240}
                        bgColor={"#ffffff"}
                        fgColor={"#1f2d3d"}
                        level={"M"}
                        includeMargin={false}
                    />
                </div>
            )}
            <div style={{ marginTop: '1.5rem' }}>
                <Spinner animation="border" style={{ color: '#FBBC04', width: '3.2rem', height: '3.2rem', borderWidth: '0.35rem' }} />
                <p className="mt-3 mb-0" style={{ fontWeight: 700 }}>Warte auf die Zahlung am Handy…</p>
            </div>
            <p className="mt-3 mb-0">
                <small>
                    <a href={paymentLinkUrl} target="_blank" rel="noopener noreferrer">Link öffnen</a>
                </small>
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowQrCodeModal(false)} style={{ minHeight: 44 }}>
                Schließen
            </Button>
        </Modal.Footer>
    </Modal>
    {/* ======================== ENDE: NEUES MODAL FÜR QR-CODE-ANZEIGE ========================= */}
</Container>
  );
};
export default BatchCodeDemoADM;